import { jsx as _jsx } from "react/jsx-runtime";
export const IconWrapper = ({ children }) => {
    return _jsx("div", { className: 'flex bg-white rounded-full justify-center items-center w-[50px] h-[50px]', children: children });
};
